export enum FetchResultType {
    Abort = 'abort',
    Error = 'error',
    NotFoundError = 'not-found-error',
    Success = 'success',
}

export interface SuccessfulFetchResult<T> {
    status: number;
    type: FetchResultType.Success;
    data: T;
    totalPages?: number;
}

export interface UnsuccessfulFetchResult<E> {
    status?: number;
    type: FetchResultType.Error | FetchResultType.NotFoundError | FetchResultType.Abort;
    error: E;
}

export interface FetchResultErrorViolation {
    propertyPath: string;
    message: string;
    code: string | number | null;
}

export interface FetchResultError {
    title: string;
    detail: string;
    type: string;
    violations: FetchResultErrorViolation[];
}

export interface FetchResultClientError {
    code: number;
    message: string;
}

export enum FetchResultSyliusErrorType {
    insufficientStock = 'insufficient-stock',
    unexpectedPrice = 'unexpected-price',
    orderChangesBlocked = 'order-changes-blocked',
    orderStateIncompatible = 'order-state-incompatible',
    orderBelongsToOtherCustomer = 'order-belongs-to-other-customer',
}

export interface FetchResultSyliusError {
    error: {
        type: FetchResultSyliusErrorType;
        message: string;
    };
}

export type FetchResult<T, E = T> = SuccessfulFetchResult<T> | UnsuccessfulFetchResult<E>;

export const isFetchResultSuccessful = <T, E>(result: FetchResult<T, E>): result is SuccessfulFetchResult<T> => (
    result.type === FetchResultType.Success
);
